import TaffiLogo from '../../../assets/svg/Taffi_Logo.svg';
import TaffiIcon from '../../../assets/svg/Taffi_Icon.svg';
import WelcomeSeperator from '../../../assets/svg/Welcome_seperator.svg';
import { capitalize } from 'lodash';
import { useStyles } from './styles';
import { trackEvent, TRACK_EVENT } from 'utils/analytics';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

export interface IIntroQuizPageProps {
    setIsSignUp: any;
}

export default function IntroQuizPage({ setIsSignUp }: IIntroQuizPageProps) {
    const classes = useStyles();
    const userDetail = useSelector((state: RootState) => state.userDetail.me);
    return (
        <div className={classes.container}>
            <div className={classes.imgContainer}>
                <img src={TaffiLogo} alt="Taffi" height={21} width={65} />
            </div>
            <div className={classes.contentContainer}>
                <div className={classes.welcomeContainer}>
                    <img src={TaffiIcon} alt="Taffi" height={56} width={56} />
                    <div className={`${classes.welcomeTitle} ${classes.textColorIntro}`}>
                        Welcome {capitalize(userDetail?.firstName)}!
                    </div>
                </div>
                <div className={classes.stylingContainer}>
                    <div className={classes.stylingText}>
                        Styling with Taffi is all about YOU. So let's start with discovering your style profile.
                    </div>
                    <img src={WelcomeSeperator} alt="Taffi" height={11} className={classes.stylingImg} />
                </div>
                <div className={`${classes.listContainer} ${classes.textColorIntro}`}>
                    <div>We promise that by the time we are done setting your profile, you would have:</div>
                    <div className={classes.list}>
                        <ul className={classes.pl20}>
                            <li>Discovered something new about yourself.</li>
                            <li>Learned a thing or two new about fashion styling.</li>
                            <li>Unlocked a truly personalized fashion world for yourself.</li>
                        </ul>
                    </div>
                </div>
            </div>
            <button
                className={`${classes.button} ${classes.introButtonColors}`}
                onClick={() => {
                    setIsSignUp(false);
                    trackEvent(TRACK_EVENT.USER_QUIZ_START, {
                        userId: userDetail?.id,
                        userType: userDetail?.userType,
                        email: userDetail?.email,
                    });
                }}
            >
                {'Discover your style'.toUpperCase()}
            </button>
        </div>
    );
}
